import { Station } from '@app/core/types/stations';
import {
  AuditSupportBulkUploadBcrFilesMutationRequest,
  AuditSupportMinUploadBcrResultDto,
  useAuditSupportBulkUploadBcrFiles,
} from '@mi-front/api-v2';
import { ValidateAndUploadFileView } from '../ValidateAndUploadFileView';
import { BcrPreview } from './BcrPreview';

export function BcrUpload({ station }: { station: Station }) {
  return (
    <ValidateAndUploadFileView<
      AuditSupportMinUploadBcrResultDto,
      { data: AuditSupportBulkUploadBcrFilesMutationRequest }
    >
      station={station}
      accept=".bcr,.BCR,.bcr.txt,.BCR.TXT,text/plain"
      fileType="BCR"
      useUploadMutation={useAuditSupportBulkUploadBcrFiles}
      renderPreview={(data) => <BcrPreview entries={data.entries ?? []} />}
    />
  );
}
